<script setup lang="ts">
import { computed } from 'vue';
import { useContentStore } from '@/stores/content';
import { useUiDisplayLocale } from '@/composables/useUiDisplayLocale';
import FeaturedNewsArticleCard from '@/components/blocks/FeaturedNewsArticleCard.vue';
import { resolveNewsArticle } from '@/utils/newsArticles';

const props = defineProps<{
  article?: number | string | null;
}>();

const contentStore = useContentStore();

const currentLocale = useUiDisplayLocale();
const listingItems = computed(() => contentStore.expandedListingItems);

const selectedArticleId = computed(() => {
  if (typeof props.article === 'number') return props.article;
  if (typeof props.article === 'string' && props.article.trim() !== '') {
    const parsed = Number.parseInt(props.article, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
});

const displayArticle = computed(() =>
  resolveNewsArticle(
    listingItems.value,
    currentLocale.value,
    selectedArticleId.value
  )
);
</script>

<template>
  <section v-if="displayArticle" class="news-article-block">
    <FeaturedNewsArticleCard :article="displayArticle" />
  </section>
</template>

<style scoped>
.news-article-block {
  min-width: 0;
}
</style>
